<template>
  <transition>
    <!-- Main -->
    <div class="pointer-events-auto z-20">
      <div
        class="flex ps-h-screen flex-col overflow-y-scroll bg-white shadow-xl"
      >
        <div>
          <div class="pb-1 sm:pb-6">
            <div>
              <div class="relative h-40 sm:h-56 bg-gray-800">
                <button
                  @click="dismissDetails()"
                  type="button"
                  class="p-2 z-10 left-5 top-5 bg-black hover:bg-gray-900 opacity-80 text-white absolute rounded-full transition-all"
                >
                  <span class="sr-only">Close panel</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-8 h-8"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                    />
                  </svg>
                </button>
                <img
                  v-if="details"
                  class="absolute h-full w-full object-cover"
                  :src="photoURLForLocation()"
                  alt=""
                />
              </div>
              <div class="px-4 mt-2 sm:mt-8 sm:flex sm:items-end">
                <div class="sm:flex-1">
                  <div>
                    <div class="flex items-center">
                      <h3 class="text-xl font-bold text-gray-900 sm:text-2xl">
                        {{ locationsStore.focusedLocation.name }}
                      </h3>
                    </div>
                  </div>
                  <div class="mt-1 mb-1 sm:mt-5 grid grid-cols-2 gap-2">
                    <a
                      @click="trackLocationEvent('Venue Directions Requested')"
                      :href="
                        'https://maps.google.com/?q=' +
                        locationsStore.focusedLocation.full_address
                      "
                      target="_blank"
                      class="col-span-1 text-center rounded-md bg-white px-3 py-2 pt-2.5 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 cursor-pointer"
                    >
                      Get Directions
                    </a>
                    <a
                      @click="trackLocationEvent('Venue Website Visited')"
                      v-if="locationsStore.focusedLocation.website"
                      :href="locationsStore.focusedLocation.website"
                      target="_blank"
                      class="col-span-1 text-center rounded-md bg-black px-3 py-2 pt-2.5 text-sm text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                      >Website</a
                    >
                    <a
                      @click="trackLocationEvent('Venue Phone Number Called')"
                      v-if="details"
                      :href="'tel:' + details.location.formatted_phone_number"
                      class="col-span-2 text-center rounded-md bg-white px-3 py-2 pt-2.5 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 cursor-pointer"
                    >
                      Call {{ details.location.formatted_phone_number }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 pb-4">
            <div
              v-if="locationsStore.focusedLocation.official_partner"
              class="rounded-md bg-green-50 p-4 mt-0"
            >
              <div class="flex">
                <div class="flex-shrink-0">
                  <svg
                    class="h-5 w-5 text-green-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div class="ml-3">
                  <h3 class="text-sm font-medium text-green-800">
                    Official Partner
                  </h3>
                  <div class="mt-2 text-sm text-green-700">
                    <p>
                      This venue is part of the PinSeeker family, and certified
                      as a great place to play PinSeeker.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="locationsStore.focusedLocation.verified"
              class="rounded-md bg-green-50 p-4 mt-0"
            >
              <div class="flex">
                <div class="flex-shrink-0">
                  <svg
                    class="h-5 w-5 text-green-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div class="ml-3">
                  <h3 class="text-sm font-medium text-green-800">
                    Verified Location
                  </h3>
                  <div class="mt-2 text-sm text-green-700">
                    <p>Confirmed location where PinSeeker is played.</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="rounded-md bg-yellow-50 p-4 mt-0">
              <div class="flex">
                <div class="flex-shrink-0">
                  <div
                    class="h-5 w-5 text-green-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  ></div>
                </div>
                <div class="ml-3">
                  <h3 class="text-sm font-medium text-green-800">
                    Unverified Location
                  </h3>
                  <div class="mt-2 text-sm text-green-700">
                    <p>
                      This location
                      <span class="italic font-bold">may</span> support
                      PinSeeker.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <dl class="space-y-4 mt-2 sm:mt-4">
              <div v-if="details && details.location.opening_hours">
                <span
                  class="rounded whitespace-nowrap px-1.5 py-1 pt-1.5 leading-5 text-xs font-medium"
                  :class="{
                    'text-green-800 bg-green-300':
                      details.location.opening_hours.open_now,
                    'text-red-800 bg-red-300':
                      !details.location.opening_hours.open_now,
                  }"
                >
                  {{
                    details.location.opening_hours.open_now
                      ? "Open Now"
                      : "Closed"
                  }}
                </span>
                <dt
                  class="text-sm font-medium text-gray-500 sm:w-40 mb-2 sm:flex-shrink-0"
                >
                  <h3 class="text-lg mt-3">Operating Hours</h3>
                </dt>
                <dd class="mt-1 text-sm text-gray-900 sm:col-span-2">
                  <ul>
                    <li
                      v-for="day in details.location.opening_hours.weekday_text"
                      :key="day"
                      class="pb-1"
                    >
                      {{ day }}
                    </li>
                  </ul>
                </dd>
              </div>
            </dl>

            <div
              v-if="!locationsStore.focusedLocation.official_partner"
              class="rounded-md bg-green-50 p-4 mt-6"
            >
              <p class="text-sm font-medium text-green-800">
                Own this venue?
                <a
                  href="https://pinseekergame.com/indoor-golf-venues/?utm=venue_locator_map"
                  target="_blank"
                  class="underline"
                  >Click here</a
                >
                to claim your PinSeeker marketing kit and become an official
                partner.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { useLocationsStore } from "../stores/locationsStore";
import { useLocationTermStore } from "../stores/locationTermStore";
import { watch, ref } from "vue";
import { storeToRefs } from "pinia";
import Bugsnag from "@bugsnag/js";

export default {
  async setup() {
    const locationsStore = useLocationsStore();
    const locationTermStore = useLocationTermStore();
    const { focusedLocation } = storeToRefs(locationsStore);
    let details = ref(null);

    if (locationsStore.focusedLocation) {
      try {
        const response = await fetch(
          `/simulator_locations/${locationsStore.focusedLocation.id}.json`,
        );
        details.value = await response.json();
      } catch (error) {
        console.error(error);
        Bugsnag.notify(error);
      }
    }

    watch(focusedLocation, async () => {
      if (locationsStore.focusedLocation) {
        try {
          const response = await fetch(
            `/simulator_locations/${locationsStore.focusedLocation.id}.json`,
          );
          details.value = await response.json();
        } catch (error) {
          console.error(error);
          Bugsnag.notify(error);
        }
      } else {
        details.value = null;
      }
    });

    return { details, locationsStore, locationTermStore };
  },
  methods: {
    trackLocationEvent(event, properties = {}) {
      this.$gtag.event(event, {
        simulator_location_id: this.locationsStore.focusedLocation.id,
        simulator_location_name: this.locationsStore.focusedLocation.name,
        simulator_location_postal_code:
          this.locationsStore.focusedLocation.postal_code,
        simulator_location_city: this.locationsStore.focusedLocation.city,
        simulator_location_subdivision_code:
          this.locationsStore.focusedLocation.subdivision_code,
        simulator_location_country_code:
          this.locationsStore.focusedLocation.country_code,
        simulator_location_official_partner:
          this.locationsStore.focusedLocation.official_partner,
        simulator_location_verified:
          this.locationsStore.focusedLocation.verified,
        ...properties,
      });
    },
    dismissDetails() {
      this.locationsStore.detailExpanded = false;
    },
    photoURLForLocation() {
      if (this.details && this.details.location.photos) {
        return `/simulator_locations_proxy/image_from_google_place?max_width=${this.details.location.photos[0].width}&photo_reference=${this.details.location.photos[0].photo_reference}`;
      } else {
        return `/simulator_locations_proxy/image_from_google_street_view?size=600x300&location=${this.details.location.geometry.location.lat},${this.details.location.geometry.location.lng}&fov=80&heading=70&pitch=0`;
      }
    },
  },
};
</script>
